export default __webpack_public_path__ + "static/media/thefeild_donation.2e09a672.svg";